/**
 * Vite entry — React 18 root
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './queryClient';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import history from 'utils/history';
import 'sanitize.css/sanitize.css';
import App from 'containers/App';
import LanguageProvider from 'containers/LanguageProvider';
import { translationMessages } from './i18n';
const mountNode = document.getElementById('app');

if (!mountNode) {
  throw new Error('Root element #app not found');
}

const root = createRoot(mountNode);

const renderApp = messages => {
  root.render(
    <QueryClientProvider client={queryClient}>
      <LanguageProvider messages={messages}>
        <HistoryRouter
          history={history}
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <App />
        </HistoryRouter>
      </LanguageProvider>
    </QueryClientProvider>,
  );
};

renderApp(translationMessages);

if (import.meta.hot) {
  import.meta.hot.accept();
}
